<template>
    <price-tag-shell :context="context">
        <div class="pt-row pt-row--top">
            <div class="pt-headline headline">
                <price-tag-value v-bind="bindField('headline')" />
            </div>
            <div class="pt-column pt-grow">
                <price-tag-product :product="context.product" />
                <div class="pt-row">
                    <span class="pt-big-number">
                        <price-tag-value v-bind="bindField('price')" />
                    </span>
                    <span class="pt-currency">{{ context.currencySymbol }}</span>
                </div>
                <div class="pt-row pt-row--between">
                    <span class="pt-small">{{ unitPriceText }}</span>
                    <price-tag-discount :percent="firstTier.discountPercent" prefix="-" />
                </div>
            </div>
        </div>
    </price-tag-shell>
</template>

<script setup>
import { computed } from 'vue';
import { isNil } from 'lodash';
import {
    priceTagLayoutProps,
    priceTagLayoutEmits,
    usePriceTagLayout,
} from '@/js/composables/usePriceTagLayout';

const props = defineProps(priceTagLayoutProps);
const emit = defineEmits(priceTagLayoutEmits);

const { bindField, tagText, formatMoney } = usePriceTagLayout(props, emit);

const firstTier = computed(() => props.context.tiers[0] || {});

const unitPriceText = computed(() => {
    const { unitPrice, product, currencySymbol } = props.context;
    if (isNil(unitPrice) || !product || !product.packUnit) return '';
    return tagText('unitPrice', {
        unit: product.packUnit,
        price: formatMoney(unitPrice),
        currency: currencySymbol,
    });
});
</script>

<style lang="scss" scoped>
@import '@style/price-tags/price-tag-layout';

.headline {
    width: 16rem;
}
</style>
